import React, { useEffect } from 'react';
import { Icon } from 'semantic-ui-react';
import * as Styles from './ViewAllTickets.styles';
import LoadingImage from 'assets/svg/loading.svg';
import TicketsDetailContainer from '../components/TicketsDetailContainer';
import { H5 } from 'utils/resuable-css';

const ViewAllTickets = ({
  pageSize,
  setPageSize,
  getTickets,
  loadingTickets,
  getSubStatus,
  getDeparment,
  loadingUrl,
  handlePortalLogin,
}) => {

  useEffect(() => {
    document.querySelectorAll('*').forEach((element) =>
      element.addEventListener('scroll', () => {
        const scrollHeight = element.scrollHeight;
        const scrollTop = element.scrollTop;
        const hasReachedBottom = scrollTop + 2200 > scrollHeight;
        hasReachedBottom && setPageSize((prev) => prev + 100);
      }),
    );
  }, [setPageSize]);

  return (
    <Styles.DraggableContainer id="alertParent">
      <div>
        <div id="alertChild">
          <Styles.TopBar>
            <Styles.Left>
              <Icon name="ticket alternate" color="black" />
              <H5>Client tickets</H5>
              {loadingTickets && <img src={LoadingImage} height={28} alt="loading" />}
            </Styles.Left>
          </Styles.TopBar>
        </div>
        <Styles.Content>
          <div>
            {getTickets?.tickets?.map((val, index) => {
              const { ticket_substatus_definitions: subStatusList } = getSubStatus || {};
              const subStatus = subStatusList?.find((status) => status.id === val.substatus);
              const { ticket_department_definitions: departmentList } = getDeparment || {};
              const department = departmentList?.find((dep) => dep.id === val.department);
              return (
                index < pageSize && (
                  <TicketsDetailContainer
                    loadingUrl={loadingUrl}
                    handlePortalLogin={handlePortalLogin}
                    key={val.id}
                    val={val}
                    department={department}
                    subStatus={subStatus}
                  />
                )
              );
            })}
          </div>
        </Styles.Content>
      </div>
    </Styles.DraggableContainer>
  );
};
export default ViewAllTickets;
